import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex-col" }
const _hoisted_2 = { class: "block p-2 max-w-xs-6 md:max-w-xs-18 bg-white rounded-lg border border-gray-200 shadow-md" }
const _hoisted_3 = { class: "flex flex-row sticky" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "h-7-5 mb-2 max-w-xs-3-5 md:max-w-xs-18 text-sm md:text-2xl font-bold tracking-tight text-blue uppercase whitespace-nowrap text-ellipsis overflow-hidden" }
const _hoisted_6 = { class: "flex-none justify-self-end w-6 md:w-10" }
const _hoisted_7 = { class: "mb-2 text-sm md:text-2xl font-bold tracking-tight text-gray-500 text-end" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-row gap-1 md:gap-2 font-bold pb-2 justify-start\"><div class=\"text-sm uppercase truncate basis-4 w-3 text-left\"></div><div class=\"text-sm uppercase basis-1/3 text-left md:hidden\">V.</div><div class=\"text-sm uppercase truncate basis-1/3 text-left hidden md:block\"> Voorstel </div><div class=\"text-sm uppercase basis-1/3 text-left md:hidden\">R.</div><div class=\"text-sm uppercase truncate basis-1/3 text-left hidden md:block\"> Result </div><div class=\"text-sm uppercase basis-1/3 text-left md:hidden\">S.</div><div class=\"text-sm uppercase truncate basis-1/3 text-center hidden md:block\"> Score </div></div>", 1)

import { computed } from "@vue/reactivity";

import { defineProps } from "Vue";
import { useStore } from "@/stores/game";
import gameRoundPlayer from "./gamePlayerRound.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'gamePlayer',
  props: ["playerIndex"],
  setup(__props) {

const props = __props

const game = useStore()


const player = game.players[props.playerIndex];
const totalScore = computed(() => {
  return player.rounds.reduce((prev: number, round: any) => {
    if (isNaN(parseFloat(round.score))) {
      return prev;
    } else {
      prev = prev + parseFloat(round.score);
      return prev;
    }
  }, 0);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(player).name.length > 9
                ? _unref(player).name.substring(0, 10) + "..."
                : _unref(player).name), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(totalScore)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(player).rounds, (round, index) => {
          return (_openBlock(), _createBlock(gameRoundPlayer, {
            key: index,
            roundIndex: index,
            playerIndex: __props.playerIndex,
            round: _unref(player).rounds[index]
          }, null, 8, ["roundIndex", "playerIndex", "round"]))
        }), 128))
      ])
    ])
  ]))
}
}

})